export enum NewsSortingOnDate {
    Newest = 'newest',
    Oldest = 'oldest',
}
